import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { PedidoConfirmarResponse } from '../adapters';

@Injectable({
    providedIn: 'root'
})
export class PedidoConfirmarHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pedido`;
    }

    /**
     * Realiza a confirmação do pedido informado alterando se status de Não Confirmado para Confirmado
     *
     * @param id ID do pedido a ser confirmado
     */
    confirmar(id: number): Observable<PedidoConfirmarResponse> {
        return this.customHttp.put<PedidoConfirmarResponse>(`${this.pathApi}/${id}/confirmar`, null);
    }
}
